'use client';


import React, { useState, useEffect } from 'react';
import './GramPanchayatNamuna8.css';

const GramPanchayatNamuna8 = () => {
  const [gramName, setGramName] = useState('घोणसई - मेट');
  const [taluka, setTaluka] = useState('आर्वी');
  const [district, setDistrict] = useState('वर्धा');
  const [yearStart, setYearStart] = useState('2020');
  const [yearEnd, setYearEnd] = useState('2023');

  // Form Data
  const [formData, setFormData] = useState({
    roadName: '', citySurveyNo: '', propertyNo: '', ownerName: '', occupierName: '',
    propertyType: '', constructionYear: '', area: '', landRate: '', buildingRate: '',
    constructionRate: '', depreciationRate: '', usageFactor: '1', rentalValue: '',
    taxRatePaise: '', houseTax: '', lightTax: '', healthTax: '', waterTax: '',
    appealHouse: '', appealLight: '', appealHealth: '', appealWater: '', shera: ''
  });

  const [records, setRecords] = useState([]);
  const [editingId, setEditingId] = useState(null);

  // Load from localStorage
  useEffect(() => {
    const saved = localStorage.getItem('namuna8ModernRecords');
    if (saved) setRecords(JSON.parse(saved));
  }, []);

  // Auto save
  useEffect(() => {
    localStorage.setItem('namuna8ModernRecords', JSON.stringify(records));
  }, [records]);

  // Live Totals
  const totalTax = 
    (parseFloat(formData.houseTax) || 0) +
    (parseFloat(formData.lightTax) || 0) +
    (parseFloat(formData.healthTax) || 0) +
    (parseFloat(formData.waterTax) || 0);

  const appealTotal = 
    (parseFloat(formData.appealHouse) || 0) +
    (parseFloat(formData.appealLight) || 0) +
    (parseFloat(formData.appealHealth) || 0) +
    (parseFloat(formData.appealWater) || 0);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setFormData({
      roadName: '', citySurveyNo: '', propertyNo: '', ownerName: '', occupierName: '',
      propertyType: '', constructionYear: '', area: '', landRate: '', buildingRate: '',
      constructionRate: '', depreciationRate: '', usageFactor: '1', rentalValue: '',
      taxRatePaise: '', houseTax: '', lightTax: '', healthTax: '', waterTax: '',
      appealHouse: '', appealLight: '', appealHealth: '', appealWater: '', shera: ''
    });
    setEditingId(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.ownerName || !formData.propertyNo) {
      alert('मालकाचे नाव आणि मालमत्ता क्रमांक भरा');
      return;
    }

    const newRecord = {
      id: editingId || Date.now(),
      sr: records.length + 1,
      ...formData,
      totalTax,
      appealTotal,
      dateAdded: new Date().toLocaleDateString('hi-IN')
    };

    if (editingId) {
      setRecords(records.map(r => r.id === editingId ? newRecord : r));
    } else {
      setRecords([newRecord, ...records]);
    }
    resetForm();
  };

  const handleEdit = (record) => {
    setFormData({
      roadName: record.roadName || '', citySurveyNo: record.citySurveyNo || '',
      propertyNo: record.propertyNo || '', ownerName: record.ownerName || '',
      occupierName: record.occupierName || '', propertyType: record.propertyType || '',
      constructionYear: record.constructionYear || '', area: record.area || '',
      landRate: record.landRate || '', buildingRate: record.buildingRate || '',
      constructionRate: record.constructionRate || '', depreciationRate: record.depreciationRate || '',
      usageFactor: record.usageFactor || '1', rentalValue: record.rentalValue || '',
      taxRatePaise: record.taxRatePaise || '', houseTax: record.houseTax || '',
      lightTax: record.lightTax || '', healthTax: record.healthTax || '',
      waterTax: record.waterTax || '', appealHouse: record.appealHouse || '',
      appealLight: record.appealLight || '', appealHealth: record.appealHealth || '',
      appealWater: record.appealWater || '', shera: record.shera || ''
    });
    setEditingId(record.id);
  };

  // ✅ FIXED: window.confirm (ESLint error गेला)
  const handleDelete = (id) => {
    if (window.confirm('ही मालमत्ता नोंद कायमची काढून टाकायची आहे का?')) {
      setRecords(records.filter(r => r.id !== id));
    }
  };

  const handlePrint = () => window.print();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-slate-50 py-12 px-6 font-serif">
      <div className="max-w-7xl mx-auto">

        {/* ==================== HEADER (सर्व setState वापरले) ==================== */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-4 bg-white px-10 py-4 rounded-3xl shadow-xl mb-6">
            <span className="text-6xl">📋</span>
            <div>
              <div className="text-5xl font-bold text-indigo-900 tracking-wide">नमुना नं. ८</div>
              <h1 className="text-4xl font-bold text-indigo-800">कर आकारणी नोंदवही</h1>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-x-10 gap-y-4 text-xl text-gray-700">
            <div>
              ग्रामपंचायत :{' '}
              <input
                value={gramName}
                onChange={(e) => setGramName(e.target.value)}
                className="border-b-2 border-dashed border-indigo-400 text-center w-52 focus:outline-none bg-transparent"
              />
            </div>
            <div>
              ता.{' '}
              <input
                value={taluka}
                onChange={(e) => setTaluka(e.target.value)}
                className="border-b-2 border-dashed border-indigo-400 text-center w-40 focus:outline-none bg-transparent"
              />
            </div>
            <div>
              जि.{' '}
              <input
                value={district}
                onChange={(e) => setDistrict(e.target.value)}
                className="border-b-2 border-dashed border-indigo-400 text-center w-40 focus:outline-none bg-transparent"
              />
            </div>
            <div>
              सन{' '}
              <input
                value={yearStart}
                onChange={(e) => setYearStart(e.target.value)}
                className="border-b-2 border-dashed border-indigo-400 text-center w-20 focus:outline-none bg-transparent"
              /> ते{' '}
              <input
                value={yearEnd}
                onChange={(e) => setYearEnd(e.target.value)}
                className="border-b-2 border-dashed border-indigo-400 text-center w-20 focus:outline-none bg-transparent"
              />
            </div>
          </div>
        </div>

        {/* ==================== ADD / EDIT FORM ==================== */}
        <div className="bg-white rounded-3xl shadow-2xl p-10 mb-16 border border-indigo-100">
          <h2 className="text-3xl font-bold text-indigo-800 mb-8 flex items-center gap-3">
            {editingId ? '📝 मालमत्ता संपादित करा' : '➕ नवी मालमत्ता जोडा'}
          </h2>

          <form onSubmit={handleSubmit} className="space-y-10">
            {/* Section 1: Basic Info */}
            <div>
              <h3 className="text-xl font-semibold text-indigo-700 mb-4 border-b pb-2">१. मूलभूत माहिती</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div><label className="block text-sm font-medium mb-1">रस्त्याचे नाव</label><input name="roadName" value={formData.roadName} onChange={handleChange} className="w-full px-5 py-3 rounded-2xl border border-gray-300 focus:border-indigo-500" /></div>
                <div><label className="block text-sm font-medium mb-1">सिटी सर्व्हे क्र.</label><input name="citySurveyNo" value={formData.citySurveyNo} onChange={handleChange} className="w-full px-5 py-3 rounded-2xl border border-gray-300 focus:border-indigo-500" /></div>
                <div><label className="block text-sm font-medium mb-1">मालमत्ता क्र.</label><input name="propertyNo" value={formData.propertyNo} onChange={handleChange} className="w-full px-5 py-3 rounded-2xl border border-gray-300 focus:border-indigo-500" required /></div>
              </div>
            </div>

            {/* Section 2: Owner & Occupier */}
            <div>
              <h3 className="text-xl font-semibold text-indigo-700 mb-4 border-b pb-2">२. मालक व भोगवटादार</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div><label className="block text-sm font-medium mb-1">मालकाचे नाव</label><input name="ownerName" value={formData.ownerName} onChange={handleChange} className="w-full px-5 py-3 rounded-2xl border border-gray-300 focus:border-indigo-500" required /></div>
                <div><label className="block text-sm font-medium mb-1">भोगवटादाराचे नाव</label><input name="occupierName" value={formData.occupierName} onChange={handleChange} className="w-full px-5 py-3 rounded-2xl border border-gray-300 focus:border-indigo-500" /></div>
              </div>
            </div>

            {/* Section 3: Property Details */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              <div><label className="block text-sm font-medium mb-1">मालमत्तेचे प्रकार</label><input name="propertyType" value={formData.propertyType} onChange={handleChange} className="w-full px-5 py-3 rounded-2xl border border-gray-300 focus:border-indigo-500" /></div>
              <div><label className="block text-sm font-medium mb-1">बांधकामाचे वर्ष</label><input name="constructionYear" value={formData.constructionYear} onChange={handleChange} className="w-full px-5 py-3 rounded-2xl border border-gray-300 focus:border-indigo-500" /></div>
              <div><label className="block text-sm font-medium mb-1">क्षेत्रफळ (चौ.फु.)</label><input name="area" type="number" value={formData.area} onChange={handleChange} className="w-full px-5 py-3 rounded-2xl border border-gray-300 focus:border-indigo-500" /></div>
              <div><label className="block text-sm font-medium mb-1">भारांक</label><input name="usageFactor" type="number" step="0.01" value={formData.usageFactor} onChange={handleChange} className="w-full px-5 py-3 rounded-2xl border border-gray-300 focus:border-indigo-500" /></div>
            </div>

            {/* Section 4: Rates */}
            <div>
              <h3 className="text-xl font-semibold text-indigo-700 mb-4 border-b pb-2">४. दर व मूल्यांकन</h3>
              <div className="grid grid-cols-1 md:grid-cols-5 gap-6 text-sm">
                <div><label>जमीन दर</label><input name="landRate" type="number" value={formData.landRate} onChange={handleChange} className="w-full px-4 py-3 rounded-2xl border" /></div>
                <div><label>इमारत दर</label><input name="buildingRate" type="number" value={formData.buildingRate} onChange={handleChange} className="w-full px-4 py-3 rounded-2xl border" /></div>
                <div><label>बांधकाम दर</label><input name="constructionRate" type="number" value={formData.constructionRate} onChange={handleChange} className="w-full px-4 py-3 rounded-2xl border" /></div>
                <div><label>घसरारा दर</label><input name="depreciationRate" type="number" value={formData.depreciationRate} onChange={handleChange} className="w-full px-4 py-3 rounded-2xl border" /></div>
                <div><label>भाडेवली मूल्य</label><input name="rentalValue" type="number" value={formData.rentalValue} onChange={handleChange} className="w-full px-4 py-3 rounded-2xl border" /></div>
              </div>
            </div>

            {/* Section 5: Taxes */}
            <div>
              <h3 className="text-xl font-semibold text-indigo-700 mb-4 border-b pb-2">५. कराची रक्कम</h3>
              <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
                <div><label>कराचा दर (पैसे)</label><input name="taxRatePaise" type="number" value={formData.taxRatePaise} onChange={handleChange} className="w-full px-5 py-3 rounded-2xl border" /></div>
                <div><label>घरपट्टी कर</label><input name="houseTax" type="number" value={formData.houseTax} onChange={handleChange} className="w-full px-5 py-3 rounded-2xl border" /></div>
                <div><label>दिवाबत्ती कर</label><input name="lightTax" type="number" value={formData.lightTax} onChange={handleChange} className="w-full px-5 py-3 rounded-2xl border" /></div>
                <div><label>आरोग्य कर</label><input name="healthTax" type="number" value={formData.healthTax} onChange={handleChange} className="w-full px-5 py-3 rounded-2xl border" /></div>
                <div><label>पाणीपट्टी कर</label><input name="waterTax" type="number" value={formData.waterTax} onChange={handleChange} className="w-full px-5 py-3 rounded-2xl border" /></div>
              </div>
              <div className="mt-6 bg-green-50 p-6 rounded-2xl text-2xl font-bold text-green-700 text-center">
                एकूण कर : ₹ {totalTax}
              </div>
            </div>

            {/* Section 6: Appeal */}
            <div>
              <h3 className="text-xl font-semibold text-indigo-700 mb-4 border-b pb-2">६. अपील / फेरफार</h3>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                <div><label>घरपट्टी अपील</label><input name="appealHouse" type="number" value={formData.appealHouse} onChange={handleChange} className="w-full px-5 py-3 rounded-2xl border" /></div>
                <div><label>दिवाबत्ती अपील</label><input name="appealLight" type="number" value={formData.appealLight} onChange={handleChange} className="w-full px-5 py-3 rounded-2xl border" /></div>
                <div><label>आरोग्य अपील</label><input name="appealHealth" type="number" value={formData.appealHealth} onChange={handleChange} className="w-full px-5 py-3 rounded-2xl border" /></div>
                <div><label>पाणीपट्टी अपील</label><input name="appealWater" type="number" value={formData.appealWater} onChange={handleChange} className="w-full px-5 py-3 rounded-2xl border" /></div>
              </div>
              <div className="mt-6 bg-purple-50 p-6 rounded-2xl text-2xl font-bold text-purple-700 text-center">
                अपील नंतर एकूण : ₹ {appealTotal}
              </div>
            </div>

            {/* Shera */}
            <div>
              <label className="block text-sm font-medium mb-2">७. शेरा / टीप / आदेश संदर्भ</label>
              <textarea name="shera" value={formData.shera} onChange={handleChange} rows={4}
                className="w-full px-5 py-4 rounded-2xl border border-gray-300 focus:border-indigo-500" 
                placeholder="नंतर वाढ किंवा घट झाल्याचा आदेश संदर्भ सह शेरा..." />
            </div>

            <div className="flex gap-6">
              <button type="submit" className="flex-1 bg-indigo-700 hover:bg-indigo-800 text-white font-bold py-5 rounded-2xl text-xl transition">
                {editingId ? 'अपडेट करा' : 'नोंद जोडा'}
              </button>
              {editingId && (
                <button type="button" onClick={resetForm} className="flex-1 bg-gray-500 hover:bg-gray-600 text-white font-bold py-5 rounded-2xl text-xl transition">
                  रद्द करा
                </button>
              )}
            </div>
          </form>
        </div>

        {/* ==================== RECORDS LIST ==================== */}
        <div className="bg-white rounded-3xl shadow-2xl p-10">
          <div className="flex justify-between items-center mb-8">
            <div>
              <h2 className="text-3xl font-bold text-gray-800">नोंदवलेल्या मालमत्ता</h2>
              <p className="text-gray-500">एकूण : <span className="font-bold text-indigo-700">{records.length}</span></p>
            </div>
            <button onClick={handlePrint} className="print:hidden bg-emerald-700 text-white px-10 py-4 rounded-2xl font-medium flex items-center gap-3 hover:bg-emerald-800">
              🖨️ पूर्ण यादी प्रिंट / PDF करा
            </button>
          </div>

          {records.length === 0 ? (
            <div className="text-center py-20 text-2xl text-gray-400">अजून कोणतीही मालमत्ता नोंदवलेली नाही</div>
          ) : (
            <div className="overflow-x-auto rounded-2xl border">
              <table className="w-full text-left min-w-full">
                <thead className="bg-indigo-50">
                  <tr>
                    <th className="p-5">अ.क्र</th>
                    <th className="p-5">मालमत्ता क्र.</th>
                    <th className="p-5">मालकाचे नाव</th>
                    <th className="p-5">क्षेत्रफळ</th>
                    <th className="p-5 text-center">एकूण कर</th>
                    <th className="p-5 text-center">अपील नंतर</th>
                    <th className="p-5 print:hidden text-center">क्रिया</th>
                  </tr>
                </thead>
                <tbody>
                  {records.map((record, idx) => (
                    <tr key={record.id} className="border-b hover:bg-indigo-50 transition">
                      <td className="p-5 font-medium">{records.length - idx}</td>
                      <td className="p-5">{record.propertyNo}</td>
                      <td className="p-5 font-medium">{record.ownerName}</td>
                      <td className="p-5">{record.area} चौ.फु.</td>
                      <td className="p-5 text-center font-bold text-green-700">₹ {record.totalTax}</td>
                      <td className="p-5 text-center font-bold text-purple-700">₹ {record.appealTotal}</td>
                      <td className="p-5 print:hidden text-center space-x-6">
                        <button onClick={() => handleEdit(record)} className="text-indigo-600 hover:underline">संपादित करा</button>
                        <button onClick={() => handleDelete(record.id)} className="text-red-600 hover:underline">काढा</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="text-center text-xs text-gray-500 mt-10 print:hidden">
          ग्रामपंचायत {gramName} • सर्व नोंदी स्वयंचलित सेव्ह होतात
        </div>
      </div>

      {/* Print Styles */}
      <style jsx global>{`
        @media print {
          .print\\:hidden { display: none !important; }
          body { background: white; }
          table { font-size: 13px; }
          th, td { padding: 8px 6px !important; }
        }
      `}</style>
    </div>
  );
};

export default GramPanchayatNamuna8;